<template>
    <div>
        <div v-if="!allowCam && isLoading" class="z-top">
            <div>{{ to }} ơi, có quà cho {{ to }}, bật Camera để thổi nến nhé</div>
            <button @click="allowCam = true; $loading();" class="m-2 btn btn-outline-success bg-light">Bật Camera</button>
        </div>
        <div v-else-if="isLoading" class="alert-warning">
            <div >Đang mở Cam, xin chờ 1 xíu</div>
        </div>
        <div v-else-if="isBurning" class="m-2">
            <div >{{ to }} thổi nến đi</div>
        </div>
        <div v-else>Tặng {{ to }} nè</div>
        <a href="#cake" ref="toCake"></a>
        <FaceMesh style="z-index: -1;" v-if="allowCam" ref="faceMesh" @results="onResults($event)" @mounted="positioningCake()" @doneLoading="onDoneLoading()" />
        <div id="cake" ref="cake" class="cake">
            <div class="plate"></div>
            <div class="layer layer-bottom"></div>
            <div class="layer layer-middle"></div>
            <div class="layer layer-top"></div>
            <div class="icing"></div>
            <div class="drip drip1"></div>
            <div class="drip drip2"></div>
            <div class="drip drip3"></div>
            <div class="candle" style="left: 25%; top: -10px;">
                <div v-if="isBurning" class="flame"></div>
            </div>
            <div class="candle" style="left: 40%; top: -30px;">
                <div v-if="isBurning" class="flame"></div>
            </div>
            <div class="candle">
                <div v-if="isBurning" class="flame"></div>
            </div>
            <div class="candle" style="left: 60%; top: -30px;">
                <div v-if="isBurning" class="flame"></div>
            </div>
            <div class="candle" style="left: 75%; top: -10px;">
                <div v-if="isBurning" class="flame"></div>
            </div>

            <div class="candle" style="left: 30%; top: 15px;">
                <div v-if="isBurning" class="flame"></div>
            </div>
            <div class="candle" style="top: 20px;">
                <div v-if="isBurning" class="flame"></div>
            </div>
            <div class="candle" style="left: 70%; top: 15px;">
                <div v-if="isBurning" class="flame"></div>
            </div>
        </div>
        <h1 ref="text" class="text"></h1>

        <Baloon v-for="left, index in baloonPositions" :key="index"
            :left="left"
         />
         <baloon v-if="heartPosition != null" :morph="true" scale="2" :left="heartPosition" color="red" />
    </div>
</template>

<script>
import FaceMesh from "@/components/MediaPipe/FaceMesh"
import Baloon from "./Baloon.vue"
import KUTE from 'kute.js'

export default {
    components: { FaceMesh, Baloon },
    data() {
        return {
            isBurning: true,
            isLoading: true,
            lips: {},
            lipsRatio: 0,
            baloonPositions: [],
            allowCam: false,
            heartPosition: null,
            to: 'Bạn',
            cheer: [
                'Chúc mừng Sinh nhật ',
            ]
        }
    },
    methods: {
        drawLips(a,c,b){
            if(c&&b){
                a.save();
                var e=a.canvas;
                for(let i in b){
                    const condition = false
                    const condition2 = i % 2 == 0 || i > 2000
                    const condition3 = 
                        i != 825 && i != 443 && i != 504 && i != 309
                    if(condition3) continue
                    let g=c[b[i][0]];
                    a.font = "10px Arial";
                    a.fillStyle = "green";
                    a.fillText(i, g.x*e.width, g.y*e.height);
                }
                a.restore()
            }
        },
        getLips(c, b){
            return {
                left: c[b[825][0]],
                top: c[b[443][0]],
                right: c[b[504][0]],
                bottom: c[b[309][0]],
                fixed1: c[b[87][0]],
                fixed2: c[b[1959][0]],
            }
        },
        getDistance(point1, point2) {
            return Math.pow(point1.x - point2.x, 2) + Math.pow(point1.y - point2.y, 2) + Math.pow(point1.z - point2.z, 2) 
        },
        onResults(results){
            if (results.multiFaceLandmarks) {
                for (const landmarks of results.multiFaceLandmarks) {
                    //this.drawLips(this.$refs.faceMesh.canvasCtx, landmarks, FACEMESH_TESSELATION);
                    let lips = this.getLips(landmarks, FACEMESH_TESSELATION)
                    this.lipsRatio = 
                        this.getDistance(lips.left, lips.bottom) +
                        this.getDistance(lips.left, lips.top) +
                        this.getDistance(lips.right, lips.bottom) +
                        this.getDistance(lips.right, lips.top)
                    this.lipsRatio /= this.getDistance(lips.fixed1, lips.fixed2)

                    if(this.getDistance(lips.top, lips.bottom) > 0.00015 && this.isBurning){
                        if(this.lipsRatio < 0.29){
                            this.sing()
                        } else if(this.lipsRatio < 0.30){
                            this.$toast.success(this.to + ' ơi, thổi mạnh hơn đi!')
                        }
                    }
                }
            }
        },
        onDoneLoading(){
            this.isLoading = false
            this.$loading().close()
            this.$refs.toCake.click()
        },
        sing(){
            if(!this.isBurning) return
            this.isBurning = false
            var audio = new Audio('/sound/birthday.mp3');
            audio.play();
            let duration = (window.innerHeight > window.innerWidth) ? 500 : 200
            this.releaseBaloon(100, duration)

            let i = 0
            this.cheer[0] += this.to
            let interval = setInterval(() => {
                if(i++ >= this.cheer.length){
                    clearInterval(interval)
                    this.showText(this.cheer[0])
                }
                if(this.cheer[i-1]) this.showText(this.cheer[i-1])
            }, 2000)

            setTimeout(() => {
                this.spinCake()
            }, 1000)
        },
        showText(text) {
            var heading = this.$refs.text

            // let's split the heading text by character
            var chars = text.split('');

            // wrap the splits into spans and build an object with these spans 
            heading.innerHTML = '<span>' + chars.join('</span><span>') + '</span>';
            var charsObject = heading.getElementsByTagName('SPAN');

            // built the tween objects
            KUTE.allFromTo(charsObject, 
                { fontSize:50, letterSpacing: 0, color: '#333'}, 
                { fontSize:80, letterSpacing: 10, color: 'red'}, 
                {offset: 75, duration: 250, repeat: 1, yoyo:true, repeatDelay: 150, easing: 'easingCubicOut'},
            ).start()

            KUTE.allFromTo(charsObject, 
                { fontSize:50, letterSpacing: 0, color: 'red'}, 
                { fontSize:80, letterSpacing: 10, color: 'white'}, 
                {offset: 75, duration: 500, repeat: 1, yoyo:false, delay: 1500, easing: 'easingCubicOut'},
            ).start()
        },
        spinCake() {
            let isMobile = this.$isMobile
            let firstDuration = 3000
            KUTE.allFromTo('.cake',
                {translateX: 0, translateZ: 100, rotateX:0, rotateY:0, rotateZ:0}, // from
                {translateX: !isMobile ? -250 : 0, translateZ: 100, rotateX:360, rotateY:15, rotateZ:5}, // to
                { duration: firstDuration }
            ).start();
            KUTE.allFromTo('.cake>div',
                {rotate:0},
                {rotate:-720},
                { delay: firstDuration, duration: 3000 }
            ).start();
        },
        releaseBaloon(max, duration){
            let i = 0
            let windowWidth = window.innerWidth
            let interval = setInterval(() => {
                if(i++ > max){
                    clearInterval(interval)
                    this.heartPosition = window.innerWidth / 4
                    if(this.$refs.text) this.$refs.text.innerHTML = 'Hết òy, nhắn thankiu ' + (this.$route.query.from ? this.$route.query.from : '') +' đi'
                }
                this.baloonPositions.push(Math.random(0, 1) * windowWidth * 2 / 3)
            }, duration)
        },
        getOS() {
            var userAgent = window.navigator.userAgent,
                platform = window.navigator.platform,
                macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
                windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
                iosPlatforms = ['iPhone', 'iPad', 'iPod'],
                os = null;

            if (macosPlatforms.indexOf(platform) !== -1) {
                return 'MacOS';
            }
            if (iosPlatforms.indexOf(platform) !== -1) {
                return 'iOS';
            }
            if (windowsPlatforms.indexOf(platform) !== -1) {
                return 'Windows';
            }
            if (/Android/.test(userAgent)) {
                return 'Android';
            }
            if (!os && /Linux/.test(platform)) {
                return 'Linux';
            }
            return os;
        },
        positioningCake() {
            this.$refs.cake.style.top = document.body.scrollHeight * 80 / 100 + "px"
        },
    },
    created() {
        if(this.$route.query.cheer) this.cheer = [...this.cheer, ...this.$route.query.cheer.split('.')]
        if(this.$route.query.to) this.to = this.$route.query.to
        if(this.$route.query.from == 'Hiếu') this.cheer = [
            ...this.cheer,
            'Đến ngày đặc biệt nhất năm rồi',
            'Chúc em mọi niềm vui và hạnh phúc mỗi ngày',
            'Hãy luôn luôn nở nụ cười nhé',
            'Anh sẽ ở bên em như cách anh đã từng trong quãng thời gian qua',
            'Anh yêu em',
            'Món quà này tuy nhỏ nhưng',
            'From Hiếu with all the love in the world.'
        ]
    },
}
</script>

<style lang="scss" scoped>
.z-top{
    position: relative; 
    z-index: 100;
}
.text{
    position: fixed;
    top: 30%;
    width: 100vw;
    text-align: center;
    color: white;
    text-shadow: 5px 5px 5px black;
}

$vanilla: #f0e4d0;
$chocolate: #553c13;

body {
    background-color: #333;
}

@mixin foodColoring($color) {
    background-color: $color;
    box-shadow:
        0 2px 0px lighten($color, 5%),
        0 4px 0px darken($color, 8.2%),
        0 6px 0px darken($color, 8.4%),
        0 8px 0px darken($color, 8.6%),
        0 10px 0px darken($color, 8.8%),
        0 12px 0px darken($color, 9%),
        0 14px 0px darken($color, 9.2%),
        0 16px 0px darken($color, 9.4%),
        0 18px 0px darken($color, 9.6%),
        0 20px 0px darken($color, 9.8%),
        0 22px 0px darken($color, 10%),
        0 24px 0px darken($color, 10.2%),
        0 26px 0px darken($color, 10.4%),
        0 28px 0px darken($color, 10.6%),
        0 30px 0px darken($color, 10.8%);
}

.cake {
    position: absolute;
    width: 250px;
    height: 200px;
    top: 50%;
    left: 50%;
    margin-top: -70px;
    margin-left: -125px;
}

.plate {
    width: 270px;
    height: 110px;
    position: absolute;
    bottom: -10px;
    left: -10px;
    background-color: #ccc;
    border-radius: 50%;
    box-shadow:
        0 2px 0 darken(#ccc, 10%),
        0 4px 0 darken(#ccc, 10%),
        0 5px 40px rgba(black, 0.5);
}

.cake > * {
    position: absolute;
}

.layer {
    position: absolute;
    display: block;
    width: 250px;
    height: 100px;
    border-radius: 50%;
    @include foodColoring($chocolate);
}

.layer-top { top: 0px; }
.layer-middle { top: 33px; }
.layer-bottom { top: 66px; }

.icing {
    top: 2px;
    left: 5px;
    background-color: $vanilla;
    width: 240px;
    height: 90px;
    border-radius: 50%;
    &:before {
        content: "";
        position: absolute;
        top: 4px;
        right: 5px;
        bottom: 6px;
        left: 5px;
        background-color: lighten($vanilla, 3%);
        box-shadow:
            0 0 4px lighten($vanilla, 5%),
            0 0 4px lighten($vanilla, 5%),
            0 0 4px lighten($vanilla, 5%);
        border-radius: 50%;
        z-index: 1;
    }
}

.drip {
    display: block;
    width: 50px;
    height: 60px;
    border-bottom-left-radius: 25px;
    border-bottom-right-radius: 25px;
    background-color: $vanilla;
}

.drip1 {
    top: 53px;
    left: 5px;
    transform: skewY(15deg);
    height: 48px;
    width: 40px;
}

.drip2 {
    top: 69px;
    left: 181px;
    transform: skewY(-15deg);
}

.drip3 {
    top: 54px;
    left: 90px;
    width: 80px;
    border-bottom-left-radius: 40px;
    border-bottom-right-radius: 40px;
}

.candle {
    background-color: #7B020B;
    width: 16px;
    height: 50px;
    border-radius: 8px / 4px;
    top: -20px;
    left: 50%;
    margin-left: -8px;
    z-index: 10;
    &:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 16px;
        height: 8px;
        border-radius: 50%;
        background-color: lighten(#7B020B, 10%);
    }
}

.flame {
    position: absolute;
    background-color: orange;
    width: 15px;
    height: 35px;
    border-radius: 10px 10px 10px 10px / 25px 25px 10px 10px;
    top: -34px;
    left: 50%;
    margin-left: -7.5px;
    z-index: 10;
    box-shadow:
        0 0 10px rgba(orange, 0.5),
        0 0 20px rgba(orange, 0.5),
        0 0 60px rgba(orange, 0.5),
        0 0 80px rgba(orange, 0.5);
    transform-origin: 50% 90%;
    animation: flicker 1s ease-in-out alternate infinite;
}

@keyframes flicker {
    0% {
        transform: skewX(5deg);
        box-shadow: 
            0 0 10px rgba(orange, 0.2),
            0 0 20px rgba(orange, 0.2),
            0 0 60px rgba(orange, 0.2),
            0 0 80px rgba(orange, 0.2) }
    25% {
        transform: skewX(-5deg);
        box-shadow:
            0 0 10px rgba(orange, 0.5),
            0 0 20px rgba(orange, 0.5),
            0 0 60px rgba(orange, 0.5),
            0 0 80px rgba(orange, 0.5) }
    50% {
        transform: skewX(10deg);
        box-shadow:
            0 0 10px rgba(orange, 0.3),
            0 0 20px rgba(orange, 0.3),
            0 0 60px rgba(orange, 0.3),
            0 0 80px rgba(orange, 0.3) }
    75% {
        transform: skewX(-10deg);
        box-shadow:
            0 0 10px rgba(orange, 0.4),
            0 0 20px rgba(orange, 0.4),
            0 0 60px rgba(orange, 0.4),
            0 0 80px rgba(orange, 0.4) }
    100% {
        transform: skewX(5deg);
        box-shadow:
            0 0 10px rgba(orange, 0.5),
            0 0 20px rgba(orange, 0.5),
            0 0 60px rgba(orange, 0.5),
            0 0 80px rgba(orange, 0.5) }
}
</style>
